import React from "react";
import "./smallPlainInsetBtnIconStyles.scss";

const SmallPlainInsetBtnIcon = ({
  onClick,
  style = {},
  className = "",
  disabled,
  text,
  icon: IconComponent,
  width,
}) => {
  const dynamicStyle = disabled
    ? { color: "black", cursor: "not-allowed" }
    : { color: "#b03a2e" };

  return (
    <button
      style={{
        width,
        ...dynamicStyle,
        ...style,
      }}
      className={`skits-chart-weekly-top-list-btn ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {IconComponent && (
        <span className="skits-chart-weekly-top-list-btn-icon">
          <IconComponent
            fillColor={dynamicStyle.color}
            strokeColor={dynamicStyle.color}
          />
        </span>
      )}
      {text}
    </button>
  );
};

export default SmallPlainInsetBtnIcon;
